<template>
  <div class="flex flex-row w-full md:w-[120px]" :class="[$style.switch]">
    <DsButton
      :variant="yesVariant"
      class="w-1/2"
      @click="proxy = true"
      :disabled="disabled"
    >
      Ja
    </DsButton>
    <DsButton
      :variant="noVariant"
      class="w-1/2"
      @click="proxy = false"
      :disabled="disabled"
    >
      Nein
    </DsButton>
  </div>
</template>

<script lang="ts" setup>
import { DsButton } from '@demvsystems/design-components';
import { computed } from 'vue';

interface Props {
  modelValue: boolean;
  disabled?: boolean;
  inputCallback?: (value: boolean) => void;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  inputCallback: undefined,
});
const emit = defineEmits(['update:modelValue']);

const yesVariant = computed(() => (props.modelValue ? 'primary' : 'outline'));

const noVariant = computed(() => (!props.modelValue ? 'primary' : 'outline'));

const proxy = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val);
    if (props.inputCallback) {
      props.inputCallback(val);
    }
  },
});
</script>

<style lang="scss" module>
.switch {
  span:first-child > button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  span:last-child > button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
